/* eslint-disable */
export const protobufPackage = 'com.celertech.marketdata.api.enums.marketdatarequesttype';

export enum MarketDataRequestType {
    SNAPSHOT = 1,
    SNAPSHOT_PLUS_UPDATES = 2,
    DISABLE_SNAPSHOTS = 3,
    UNRECOGNIZED = -1
}
